module.exports = __webpack_public_path__ + "static/media/tribute.7ddd1c78.png";